export default "__VITE_ASSET__DLJBJopy__"